import connection from '../../../../api/config/connection'

export default {
  autofill: async (url, postalcode, housenumber, housenumberAddition) => {
    const options = {
      url,
      method: 'POST',
      //Params map to https://api.postnl.nl/address/national/v1/validate
      params: {
        PostalCode: postalcode.toUpperCase(),
        HouseNumber: housenumber,
        Addition: housenumberAddition
      }
    };

    let response;
    try {
      response = await connection.instance()(options);
    } catch(error) {
      let message;
      try {
        message = error.response.data.result.errors[0].detail;
      } catch(error) {
        return {
          street: '',
          city: ''
        }
      }
      throw new Error(`API Error: ${message}`);
    }

    const data = response.data.result;
    if(!data || !data.length) {
      return {
        street: '',
        city: ''
      }
    }

    return {
      street: data[0].street,
      city: data[0].city
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/AutofillAdressSources/PostNL.js